<template>
  <div class="app-container">
    <el-form
      ref="queryForm"
      label-position="left"
      :model="queryParams"
      :inline="true"
      style="display:flex"
    >
      <el-form-item
        label
        prop="siteId"
      >
        <el-select
          v-model="queryParams.siteId"
          placeholder="请选择站点"
          clearable
          style="width:100%"
          @change="getList"
        >
          <el-option
            v-for="dict in siteOptions"
            :key="dict.siteId"
            :label="dict.siteName"
            :value="dict.siteId"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label
        prop="devId"
      >
        <el-select
          v-model="queryParams.devId"
          placeholder="请选择传感器"
          clearable
          style="width:100%"
          :disabled="devCanSelect"
          @change="getList"
          @visible-change="handleDev"
        >
          <el-option
            v-for="dict in devOptions"
            :key="dict.devId"
            :label="dict.devName"
            :value="dict.devId"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label
        prop="param"
      >
        <el-select
          v-model="queryParams.param"
          placeholder="请选择参数类型"
          clearable
          style="width:100%"
          :disabled="attrCanSelect"
          @change="getList"
          @visible-change="handleAttributesById"
        >
          <el-option
            v-for="dict in attributesOptions"
            :key="dict.attributeId"
            :label="dict.name"
            :value="dict.attributeId"
            style="width:400px"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="预警日期"
        prop="devId"
      >
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="getList"
        />
      </el-form-item>
    </el-form>
    <div class="log">
      <el-table
        v-loading="loading"
        :data="tableData"
        align="center"
        style="width:100%"
      >
        <el-table-column
          label="站点名称"
          align="center"
          prop="siteName"
        />
        <el-table-column
          label="设备ID"
          align="center"
          prop="devId"
        />
        <el-table-column
          label="设备名称"
          align="center"
          prop="devName"
        />
        <el-table-column
          label="预警参数"
          align="center"
          prop="attributeName"
          width="220"
        />
        <el-table-column
          label="预警类型"
          align="center"
          prop="type"
        >
          <template slot-scope="scope">
            <span>{{ strategyTypeFormat(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="上报值/单位"
          align="center"
          prop="reporteValue"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.reporteValue }}{{ scope.row.unit }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="阈值"
          align="center"
          prop="status"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.devMin }}{{ scope.row.unit }} / {{ scope.row.devMax }} {{ scope.row.unit }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="预警时间"
          align="center"
          prop="createTime"
        />
        <el-table-column
          label="备注"
          align="center"
          prop="remarks"
        >
          <template slot-scope="scope">
            <span
              :class="{'col-a4dcf5':!scope.row.remarks}"
              @click="openMsg(scope.row)"
            >{{ scope.row.remarks?scope.row.remarks:'增加' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="预警策略"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              round
              @click="handleUpdate(scope.row)"
            >
              修改
            </el-button>
            <!-- <el-button size="mini" type="text" @click="handleUpdate(scope.row)" class="edit-tv">修改</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        layout="total, prev, pager, next, jumper"
        @pagination="getList"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { listLog, getWarnNumberCount, updateLog } from '@/api/analysis/log'
import { listDevice } from '@/api/org/device'
import {
  listStrategy,
  getStrategy,
  delStrategy,
  addStrategy,
  updateStrategy,
  attributesById
} from '@/api/strategy/warning'
// import { delete } from 'vue/types/umd';
export default {
  components: {},
  props: {
    siteRow: Object
  },
  // 定义属性
  data () {
    return {
      siteOptions: [],
      total: 0,
      dateRange: [],
      strategyTypeOptions: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        siteId: undefined,
        devId: undefined,
        param: undefined
      },
      tableData: [],
      // 是否显示弹出层
      open: false,
      // 弹出层标题
      title: '',
      attributesOptions: [],
      // 表单参数
      form: { siteId: undefined },
      // 表单校验
      rules: {},
      abnormalCount: 0, // 异常数
      urgentCount: 0, // 紧急数
      siteName: '', // 站点名称
      devOptions: [],
      attrCanSelect: true,
      devCanSelect: true
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {
    siteRow: {
      handler: function (val) {
        if (Object.keys(val).length > 0) {
          this.$set(this.queryParams, 'siteId', val.siteId)
          this.$set(this.queryParams, 'devId', val.devId)
          this.getList()
        }
      },
      immediate: true
    },
    'queryParams.siteId': function (val, oldVal) {
      this.devCanSelect = !(val && val != '')
      if (this.devCanSelect) {
        this.$delete(this.queryParams, 'devId')
      }
    },
    'queryParams.devId': function (val, oldVal) {
      this.attrCanSelect = !(val && val != '')
      if (this.attrCanSelect) {
        this.$delete(this.queryParams, 'param')
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getList()
    this.getDicts('sys_warning_strategy_type').then((response) => {
      this.strategyTypeOptions = response.data
    })
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.siteOptions = this.$store.getters.siteList
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {},
  // 方法集合
  methods: {
    getList () {
      this.loading = true
      listLog(this.addDateRange(this.queryParams, this.dateRange)).then(
        (response) => {
          this.loading = false
          this.tableData = response.rows
          this.total = response.total
        }
      )
    },
    handleCurrentChange (val) {
      this.$set(this.queryParams, 'pageNum', val)
      this.getList()
    },
    resetQuery () {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery () {
      this.queryParams.pageNum = 1
      this.getList()
    },

    /** 修改按钮操作 */
    handleUpdate (row) {
      // this.open = true;
      // this.reset();
      // const id = row.warningStrategyId;
      // getStrategy(id).then((response) => {
      //   this.form = response.data;
      //   if (response.data != undefined) {
      //     this.open = true;
      //     this.title = "修改策略";
      //     this.handleDev(row);
      //     this.handleAttributesById(row);
      //   } else {
      //     this.msgSuccess("该策略禁止修改");
      //   }
      // });
      this.$router.push({
        name: 'updateStatic',
        query: {
          id: row.warningStrategyId
        }
      })
    },
    handleDev (row) {
      this.form.siteId = this.queryParams.siteId
      listDevice({ siteId: this.form.siteId }).then((response) => {
        this.devOptions = response.rows
      })
    },

    handleAttributesById (row) {
      this.form.devId = this.queryParams.devId
      attributesById({ devId: this.form.devId }).then((response) => {
        this.attributesOptions = response.data.attributesList
      })
    },
    strategyTypeFormat (row, column) {
      return this.selectDictLabel(this.strategyTypeOptions, row.type)
    },

    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },

    // 表单重置
    reset () {
      this.form = {
        status: '0',
        delFlag: undefined,
        createBy: undefined,
        createTime: undefined,
        updateBy: undefined,
        updateTime: undefined,
        id: undefined,
        warningName: undefined,
        attributeId: undefined,
        duration: undefined,
        aberrantMax: undefined,
        aberrantMin: undefined,
        urgentMax: undefined,
        urgentMin: undefined,
        intervals: undefined,
        frequency: undefined,
        siteId: undefined,
        devId: undefined,
        siteName: undefined,
        attributeName: undefined,
        devName: undefined
      }
      this.resetForm('form')
    },

    handleAttribDev () {
      const attribute = this.attributesOptions.find((s) => {
        console.log(this.form.attributeId)
        return s.attributeId === this.form.attributeId
      })

      this.form.attributeName = attribute.name
    },

    /** 提交按钮 */
    submitForm: function () {
      const urgentMaxValue = this.form.urgentMax
      const urgentMinValue = this.form.urgentMin
      const aberrantMaxValue = this.form.aberrantMax
      const aberrantMinValue = this.form.aberrantMin
      if (urgentMaxValue === '' || urgentMaxValue === undefined) {
        this.msgError('请填写生理上限')
        return
      }
      if (urgentMinValue === '' || urgentMinValue === undefined) {
        this.msgError('请填写适宜上限')
        return
      }
      if (aberrantMaxValue === '' || aberrantMaxValue === undefined) {
        this.msgError('请填写适宜下限')
        return
      }
      if (aberrantMinValue === '' || aberrantMinValue === undefined) {
        this.msgError('请填写生理下限')
        return
      }
      if (parseFloat(urgentMaxValue) <= parseFloat(urgentMinValue)) {
        this.msgError('生理上限必须大于适宜上限')
        return
      }
      if (parseFloat(urgentMinValue) <= parseFloat(aberrantMaxValue)) {
        this.msgError('适宜上限必须大于适宜下限')
        return
      }
      if (parseFloat(aberrantMaxValue) <= parseFloat(aberrantMinValue)) {
        this.msgError('适宜下限必须大于生理下限')
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.handleAttribDev()
          if (this.form.id != undefined) {
            updateStrategy(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess('修改成功')
                this.open = false
                this.getList()
              }
            })
          } else {
            addStrategy(this.form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess('新增成功')
                this.open = false
                this.getList()
              }
            })
          }
        }
      })
    },
    // 增加备注
    openMsg (row) {
      console.log(row)
      const h = this.$createElement
      this.$prompt('', '添加备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'myClass',
        inputMaxlength: 10,
        inputValue: row.remarks,
        inputShowWordLimit: true,
        inputValidator: function (data) {
          if (data.length > 30) {
            return false
          } else {
            return true
          }
        },
        inputErrorMessage: '输入字数超出，最多课输入30个字符'
      }).then(({ value }) => {
        this.$set(this.form, 'remarks', value)
        this.$set(this.form, 'id', row.id)
        updateLog(this.form).then((response) => {
          if (response.code === 200) {
            this.msgSuccess('备注添加成功')
            this.getList()
          }
        })
      }).catch(() => {
        this.$message({
          message: '取消输入'
        })
			  })
      // 	 let  _this = this
      // 	 const h = _this.$createElement;

    // _this.$msgbox({
    //     title: '消息',
    //     message: h('p', null, [
    //         h('input', {
      // 					 attrs:{
      // 						 id:'commentContent'
      // 					 }
      // 				}),
    //       ]),
    //       showCancelButton: true,
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //     showCancelButton: true,
    //     confirmButtonText: '评论',
    //     cancelButtonText: '取消',
    //     beforeClose: (action, instance, done) => {
    //         if (action === 'confirm') {
    //           instance.confirmButtonLoading = true;
    //           instance.confirmButtonText = '执行中...';
    //           setTimeout(() => {
    //             done();
    //             setTimeout(() => {
    //               instance.confirmButtonLoading = false;
    //             }, 300);
    //           }, 300);
    //         } else {
    //           done();
    //         }
    //     }
    // }).then(({value}) => {
    //     _this.$message({
    //         type: 'info',
    //         message: 'action: ' + value
    //     });
    // });
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang='scss' scoped>
.col-a4dcf5{
	color: #a4dcf5 !important;
	border-bottom: 1px solid #a4dcf5;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.add-btn {
  position: absolute;
  right: 20px;
}
.tip-div {
  display: flex;
  align-items: center;
}
.block {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.site-tv {
  margin-left: 20px;
  font-size: 18px;
  color: #666666;
}

.yell-tv {
  color: #f9b83f;
}

.edit-tv {
  font-size: 16px;
  color: #3b77aa;
}

.log{
  .el-button{
    background: transparent;
    color: white;
		padding: 9px 20px;
		&:hover{
			background-color: #2694c2;
			border-color:#2694c2;
		}
  }
}
</style>
<style>
.msg-contain .el-tabs{
	overflow: auto;
}
.myClass{
	width: 400px !important;
	height: 220px !important;
	border: none !important;
}
.myClass .el-message-box__header{
	/* height: 36px; */
	color: #fff;
	font-size: 18px;
	background-color: #2b94c2;
}
.myClass .el-message-box__header .el-message-box__title{
	color: #fff !important
}
.myClass .el-message-box__headerbtn .el-message-box__close {
  color: #fff;
}
.myClass .el-message-box__content{
	text-align: center;
}
.myClass .el-message-box__input{
	width: 300px;
	display: inline-block;
}
.myClass .el-message-box__btns{
	text-align: center;
}
.myClass .el-input__inner{
	border-color: #ccc !important;
}
</style>
